<div class="ui-grid ui-grid-responsive ui-fluid">
  <div class="ui-dialog-content Loyalty">
    <div class="ui-g-12">
        <span class="label"> {{ 'customerCompany.classification' | translate }}</span>
    </div>
  </div>
</div>

<div class="ui-g-12 ui-fluid" *ngFor="let classification of classificationTypes; let i=index">
  <div class="ui-dialog-content Loyalty">
    <div class="ui-g-6 ui-md-6">
      <span class="label"> {{ classification.name }}</span>
    </div>
  </div>
  <div class="ui-dialog-content Loyalty">
    <div class="ui-g-6 ui-md-6">
      <p-dropdown [options]="classificationDetails[i]" [(ngModel)]="selectedClassifications[classification.name]" [style]="{'width':'100%'}"></p-dropdown>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-classification/store-common-classification.component.html